package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.auth.ContractTypeDto
import com.evoapps.evoshift.domain.model.ContractType
import com.evoapps.evoshift.domain.model.SystemContractType

class ContractTypeMapper {
    fun toDomain(dto: ContractTypeDto): ContractType {
        return ContractType(
            id = dto.id,
            label = dto.label,
            systemType = try {
                SystemContractType.valueOf(dto.systemType)
            } catch (e: Exception) {
                SystemContractType.NOT_SET
            },
            countryCode = dto.countryCode
        )
    }

    fun toDto(domain: ContractType): ContractTypeDto {
        return ContractTypeDto(
            id = domain.id,
            label = domain.label,
            systemType = domain.systemType.name,
            countryCode = domain.countryCode
        )
    }
}
